import { BoutonDocument } from './BoutonDocument.jsx';
import { dateSuisse } from '../lib/dates';
import { tr } from '../lib/i18n';
import { C } from '../theme/palette';

/** Intitulé de chaque nature, dans la langue de l'écran ; le serveur l'écrit en français. */
const TITRES = {
  LETTRE_DEMISSION: 'Lettre de démission',
  LETTRE_LICENCIEMENT: 'Lettre de résiliation',
  CERTIFICAT_TRAVAIL: 'Certificat de travail',
  CERTIFICAT_SALAIRE: 'Certificat de salaire',
  ATTESTATION_TRAVAIL: 'Attestation de travail',
};

/**
 * Lettres et certificats d'un employé, chacun ouvert en PDF tel qu'il a été figé.
 *
 * <p>La même liste sert des deux côtés : l'employé y lit sa lettre de
 * résiliation et ses certificats ; la direction, la démission qu'il a remise.
 *
 * @param {object} props propriétés
 * @param {{id: number, type: string, titre: string, emisLe: string}[]} props.documents documents, le plus récent d'abord
 * @param {(id: number) => string} props.cheminDe chemin du PDF d'un document, sous `/api`
 * @param {string} props.vide phrase affichée sans document
 * @param {string} [props.titre] titre de la liste
 * @returns {JSX.Element} la liste
 */
export function ListeDocuments({ documents, cheminDe, vide, titre = '📂 Lettres et certificats' }) {
  const liste = documents || [];
  return (
    <div style={{ marginBottom: 14 }}>
      <div
        style={{
          fontSize: 9,
          fontWeight: 800,
          color: C.muted,
          textTransform: 'uppercase',
          letterSpacing: 0.5,
          marginBottom: 6,
        }}
      >
        {titre}
      </div>
      {liste.length === 0 ? (
        <div
          style={{
            fontSize: 10.5,
            color: C.muted,
            lineHeight: 1.6,
            background: C.navyXL,
            borderRadius: 9,
            padding: '10px 12px',
          }}
        >
          {vide}
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {liste.map((d) => (
            <div
              key={d.id}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 8,
                border: '1px solid ' + C.border,
                borderRadius: 9,
                padding: '7px 10px',
              }}
            >
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 11, fontWeight: 800, color: C.navy }}>
                  {TITRES[d.type] ? tr(TITRES[d.type]) : d.titre}
                </div>
                <div style={{ fontSize: 9, color: C.muted }}>{dateSuisse(d.emisLe)}</div>
              </div>
              <BoutonDocument chemin={cheminDe(d.id)} label="📄 PDF" color={C.green} sm />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
